import React, {useEffect, useState} from 'react'
import { 
    Grid, 
    Typography, 
    CardContent, 
    Card, 
    TextField, 
    FormControl, 
    FormHelperText, 
    Accordion, 
    AccordionDetails, 
    AccordionSummary, 
    
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {styles} from "./styles";
import _ from "lodash";
import * as yup from 'yup';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import QuestionLinearDisabled from "../../../../../components/common/resultEvaluation/evaluation/questionLinearScale";
import QuestionTex from "../../../../../components/common/resultEvaluation/evaluation/questionText"
import { useStateValue } from './../../../../../context/store';

const Index = (props) => {
    const classes = styles();
    const [{ valorationAplication}, dispatch] = useStateValue()

    const [dataYup, ] = useState({})
    const [expanded, setExpanded] = useState({});

    const schema = yup.object().shape(dataYup);
    const {register, formState:{errors } } = useForm({
        resolver: yupResolver(schema),
        mode: 'onTouched',
        reValidateMode: 'onChange'
    })
    
     
    useEffect(() => {
        dispatch({
            type: "SET_VALORATE_APLICATION",
            disabledValors: valorationAplication?.disabledValors,
            data:  {competences :props?.dataDetail?.performanceEvaluation?.competences?.map((x,index)=> (
                {
                    uuid: x?.competence?.uuid,  
                    value: x?.value,  
                    position: index,
                    conducts:  x?.conducts?.map((c, pos=index)=> (
                        {
                            uuid: c?.uuid,
                            position: pos,
                            value: c?.value,
                            questions: c?.questions?.map((q, posQ=index)=> (
                                {
                                    uuid: q?.uuid,
                                    value: x?.value,
                                    position: posQ
                                }
                            ))
                        }
                    ))       
                }
             ))}
         })
       
    }, [])
    

    const handleChange = (panel) => {
      
        if(expanded[panel]){
            const differents = {...expanded, [panel]:false}
            setExpanded(differents)
        }else {

            setExpanded({...expanded, [panel]: true});
        }
      };


      const typeQuestion = (comp, beh, val) => {

        if(val?.answerAlternativeCode === 'ESL'){
            return  (
                <QuestionLinearDisabled 
                    competenceId={comp?.competence?.uuid}
                    behaviorId={beh?.uuid}
                    uuid={val?.uuid}
                    valuesRanking={val?.questionAlternativeList}
                    question={val?.question}
                /> 
            )
        }else if(val?.answerAlternativeCode === 'TEX'){
            return (
                <QuestionTex 
                    competenceId={comp?.competence?.uuid}
                    behaviorId={beh?.uuid}
                    uuid={val?.uuid}
                    question={val?.question}
                    value={val?.questionAlternativeList[0]?.value}
                />
            )
        }
        
    }
       
  
    return (
     
        <Grid container spacing={2} justifyContent="center" >
            {props?.dataDetail?.performanceEvaluation?.competences?.sort((a, b)=> Number(a?.position) - Number(b?.position) )?.map((c,index)=> (
            <Grid item lg={12}>
                 <Accordion expanded={expanded[`Competence${index+1}`]} onChange={()=>handleChange(`Competence${index+1}`)}>
                    <AccordionSummary 
                        aria-controls="panel1d-content" 
                        id="panel1d-header" 
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Grid item container lg={12} md={12} style={{background: 'rgba(154, 187, 100, 0.46)', borderRadius: 5}} alignItems="center" >
                            <Grid item lg={12} md={7} sm={12} xs={12}>
                                <Typography className={classes.titleCriteria}>{`Criterio ${index+1}`} </Typography>
                            </Grid>
                        </Grid>
                    </AccordionSummary>

                <AccordionDetails>
                    <Grid item lg={12} md={12}>
                        <Typography style={{textAlign: 'justify', fontSize: 14, fontWeight: 400, color: '#8E8E8E', margin: ' 10px auto 20px auto'}}>{c?.competence?.name} </Typography>
                    </Grid>
                </AccordionDetails>

                {_.orderBy(c?.conducts, ['position'],["asc"])?.map((b, posB=index)=> (
                    <Accordion expanded={expanded[`Aspecto ${posB+1}`]} onChange={()=>handleChange(`Aspecto ${posB+1}`)}>
                        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header"  expandIcon={<ExpandMoreIcon />}>
                        <Grid item container lg={12} md={12} style={{background: 'rgba(245, 178, 117, 0.55)', borderRadius: 5}} alignItems="center">
                            <Grid item lg={12} md={12} style={{justifyContent: 'end'}}>
                                <Typography className={classes.titleCriteria}>{`Aspecto ${posB+1}`} </Typography>
                            </Grid>
                        </Grid>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid item lg={12} md={12}>
                                <Typography style={{textAlign: 'justify', fontSize: 14, fontWeight: 400, color: '#8E8E8E', margin: ' 10px auto 20px auto'}}>{b?.name} </Typography>
                            </Grid>
                            {_.orderBy(b?.questions, ['position'],["asc"])?.map((x, index)=> (
                                <>
                                    <Grid item container lg={12} md={12} >
                                        <Grid item lg={12} style={{textAlign: 'center'}}>
                                            <Typography className={classes.key} style={{ fontSize: 20, fontWeight: 400, background: '#B7C1F3'}}>{`Pregunta ${index+1}`} </Typography>
                                        </Grid>
                                        <Grid item lg={12} style={{textAlign: 'center'}}>
                                            <Typography className={classes.value} style={{ wordBreak: 'break-all', margin: ' 10px auto 20px auto'}}>{x?.question}</Typography>
                                        </Grid>
                                    </Grid> 
                                    <Grid item={10} style={{marginBottom: 40}}>
                                        {typeQuestion(c, b, x)}
                                    </Grid>
                                </>
                            ))}
                        </AccordionDetails>
                    </Accordion>
                ))}

         </Accordion>
          
        </Grid>
            ))}
            {/* <Grid item lg={12} md={12}>
                  <Card elevation={3} style={{ background:'rgb(239 239 239)', padding: 5, marginBottom: '3%'}}>
                    <CardContent style={{background:  '#5EA058' }}>
                        <Grid item container lg={12} alignItems="center" justifyContent="space-between">
                            <Grid item lg={6.8} md={7}>
                                <Typography style={{textAlign: 'start', fontSize: 20, fontWeight: 400, background: '#5EA058', color: '#ffffff'}}>RESULTADO</Typography>
                            </Grid>
                            <Grid item container lg={5.2} md={5} alignItems="center" justifyContent="space-between">
                                <Grid item xs={12} sm={12} md={12} lg={4} style={{display: 'flex', alignItems: 'center'}}>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={8} style={{display: 'flex', alignItems: 'center'}}>
                                    <Grid item lg={8}>
                                        <Typography className={classes.titleLabelsTotal}>Rendimiento general</Typography>
                                    </Grid>
                                    <Grid item lg={4}>
                                        <FormControl variant='outlined' fullWidth size="small">
                                            <TextField
                                                className={classes.dropdown}
                                                fullWidth
                                                disabled
                                                value={`${props?.dataDetail?.performanceEvaluation?.totalResultPercentage}%`}
                                                InputLabelProps={{
                                                    shrink:  true,
                                                    notched: true,
                                                }}
                                                size="small"
                                
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                       
                    </CardContent>
                </Card>
            </Grid> */}
        </Grid>
    )
}

export default Index